import { loadTotal, chargeAmount } from './loadStore';

const money = (n) => `$${(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const dt = (s) => (s ? new Date(s).toLocaleString() : '—');
const party = (p) => `${p.name || ''}<br>${p.address || ''}<br>${[p.city, p.state, p.zip].filter(Boolean).join(', ')}<br>${p.phone ? 'Ph: ' + p.phone : ''} ${p.contact ? '· ' + p.contact : ''}`;

// render every stop (multi-pickup / multi-delivery) in order
function stopsHtml(load) {
  const stops = (load.stops && load.stops.length) ? load.stops
    : [{ type: 'pickup', ...load.shipper, early: load.pickup.early, late: load.pickup.late }, { type: 'delivery', ...load.consignee, early: load.delivery.early, late: load.delivery.late }];
  let pc = 0, dc = 0;
  const cards = stops.map((s) => {
    const isP = s.type === 'pickup';
    const n = isP ? ++pc : ++dc;
    return `<div class="box" style="border-left:4px solid ${isP ? '#16a34a' : '#dc2626'}">
      <div class="lbl">${isP ? '🚚 Pickup' : '🏁 Delivery'} #${n}</div>
      <div style="margin:4px 0">${party(s)}</div>
      <div class="muted">Appt: ${dt(s.early)}${s.late ? ' – ' + dt(s.late) : ''}<br>${s.refNumber ? (isP ? 'Pickup #: ' : 'Ref/PO #: ') + s.refNumber + '<br>' : ''}${s.commodity ? s.commodity + (s.weight ? ' · ' + s.weight + ' lb' : '') : ''}${s.notes ? '<br><i>' + s.notes + '</i>' : ''}</div>
    </div>`;
  }).join('');
  return `<div class="grid">${cards}</div>`;
}

// Opens a print-ready driver dispatch sheet in a new window.
export function printDispatchSheet(load, driverName, vehicleName) {
  const rows = (load.charges || []).map((c) => `<tr><td>${c.code || ''}</td><td>${c.description || ''}</td><td style="text-align:right">${c.qty}</td><td style="text-align:right">${money(c.rate)}</td><td style="text-align:right">${money(chargeAmount(c))}</td></tr>`).join('');
  const refs = (load.references || []).map((r) => `${r.type}: <b>${r.number}</b>`).join(' &nbsp; ');
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Dispatch ${load.billNumber}</title>
  <style>
    body{font-family:-apple-system,Segoe UI,Roboto,sans-serif;color:#0f172a;margin:28px;font-size:13px}
    h1{font-size:22px;margin:0}
    .muted{color:#64748b}
    .grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin:14px 0}
    .box{border:1px solid #cbd5e1;border-radius:8px;padding:10px}
    .lbl{font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px}
    table{width:100%;border-collapse:collapse;margin-top:8px}
    th,td{border-bottom:1px solid #e2e8f0;padding:6px 8px;text-align:left}
    th{font-size:11px;color:#475569;text-transform:uppercase}
    .total{text-align:right;font-size:16px;font-weight:800;margin-top:8px}
    .head{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #0066ff;padding-bottom:8px}
  </style></head><body>
  <div class="head">
    <div><h1>DISPATCH SHEET</h1><div class="muted">Dynamic Dispatch · Dynamics BPO</div></div>
    <div style="text-align:right"><div class="lbl">Bill / Load #</div><div style="font-size:20px;font-weight:800">${load.billNumber}</div><div class="muted">${new Date().toLocaleDateString()}</div></div>
  </div>

  <div class="grid">
    <div class="box"><div class="lbl">Driver</div><div style="font-weight:700">${driverName || '—'}</div></div>
    <div class="box"><div class="lbl">Truck / Unit</div><div style="font-weight:700">${vehicleName || '—'}</div>${load.tripNumber ? `<div class="muted">Trip ${load.tripNumber}</div>` : ''}</div>
  </div>

  ${stopsHtml(load)}

  <div class="box"><div class="lbl">Load details</div>
    <div>${load.pieces || '—'} pcs · ${load.commodity || '—'} · ${load.description || ''} ${load.weight ? '· ' + load.weight + ' lb' : ''}</div>
    ${refs ? `<div style="margin-top:6px">${refs}</div>` : ''}
  </div>

  <table><thead><tr><th>Code</th><th>Description</th><th style="text-align:right">Qty</th><th style="text-align:right">Rate</th><th style="text-align:right">Amount</th></tr></thead><tbody>${rows || '<tr><td colspan=5 class="muted">No charges entered</td></tr>'}</tbody></table>
  <div class="total">Total: ${money(loadTotal(load))}</div>

  ${load.notes ? `<div class="box" style="margin-top:12px"><div class="lbl">Notes / Special instructions</div><div>${load.notes}</div></div>` : ''}

  <div style="margin-top:24px;display:flex;gap:30px">
    <div style="flex:1;border-top:1px solid #333;padding-top:4px" class="muted">Driver signature</div>
    <div style="flex:1;border-top:1px solid #333;padding-top:4px" class="muted">Date</div>
  </div>
  <script>window.onload=()=>window.print()</script>
  </body></html>`;
  const w = window.open('', '_blank');
  if (w) { w.document.write(html); w.document.close(); }
  else alert('Allow pop-ups to print the dispatch sheet.');
}
